export default __webpack_public_path__ + "static/media/Mobile.64d5be86.png";